import { useSelector } from 'react-redux';

import { getShowPartnerVerifyModal } from '@perpay-web/authentication/selectors';
import { setUserVerificationModalOpen } from '@perpay-web/components/actions/userVerificationModal';
import { useAnimatedModal } from '@perpay-web/components/base/Modal/useAnimatedModal';
import { useModal } from '@perpay-web/components/base/Modal/useModal';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useUserVerificationModal = () => {
    const showPartnerVerifyModal = useSelector(getShowPartnerVerifyModal);
    const { isModalOpen, setIsModalOpen } = useModal(showPartnerVerifyModal);

    const {
        isAnimatedModalOpen,
        setIsAnimatedModalOpen,
        animatedModalClassName,
    } = useAnimatedModal({ isModalOpen, setIsModalOpen });

    return {
        isAnimatedModalOpen,
        setIsAnimatedModalOpen,
        animatedModalClassName,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useUserVerificationModal();
        useActionObservableCallback(
            hookAction$,
            setUserVerificationModalOpen.type,
            (value) => hook.setIsAnimatedModalOpen(value),
        );
        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };
    return Provider;
};

const [UserVerificationModalProvider, useUserVerificationModalContext] =
    createContextProvider(providerFactory);

export { UserVerificationModalProvider, useUserVerificationModalContext };
